const WasteTypeId = Object.freeze({
  pszok: 'pszok',
  baterie: 'baterie',
  apteka: 'apteka',
  gabaryt: 'gabaryt',
});

export default WasteTypeId;
